import {createQuizSessionEndUpdate} from '@cp/model';
import {serverTimestamp, updateDoc} from 'firebase/firestore';
import getQuizSessionDoc from './getQuizSessionDoc';
import {getQuizSessionDocRef} from './getQuizSessionDocRef';

/**
 * End a quiz session early (mirrors backend endQuizSession).
 * Marks unanswered questions as selectedAnswer '' and isCorrect false, sets endedAt.
 * Progress penalise for unanswered and streak are not implemented in the app.
 */
export default async function endQuizSessionDoc(uid: string, sessionId: string): Promise<void> {
  const session = await getQuizSessionDoc(uid, sessionId);
  if (!session) {
    throw new Error('Session not found');
  }

  const {questions: allEndedQuestions, state} = createQuizSessionEndUpdate(session.questions);
  const ref = getQuizSessionDocRef(uid, sessionId);
  await updateDoc(ref, {
    questions: allEndedQuestions,
    endedAt: serverTimestamp(),
    state,
  });
}
